import { useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { GAME_LAUNCH_TRIGGER } from '../config/constants';
import { getParam, parseCoinType, parseGameId } from '../utils/marketingHelper';

const SLOT_GAME_DEEP_LINK_VALUE = 'slot-game';

/**
 * OneLink web fallback for `deep_link_value=slot-game` (game in `deep_link_sub7`, coin in `deep_link_sub8`),
 * shared with the mobile app. Hands off to `/games/:gameId?mode=` so the coin switch goes through the
 * game screen's SC checks. Waits for the boot (auth flow done + profile loaded), like the /crown-rips deep link,
 * so a guest keeps the params through sign-up and post-auth steps are not skipped.
 */
export const useSlotGameDeepLink = (isBootReady: boolean) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isSlotGameLink = getParam(searchParams, 'deep_link_value') === SLOT_GAME_DEEP_LINK_VALUE;
  // OX Agent: Open redirect prevented — navigation target built only from a validated numeric id and allowlisted coin
  const gameId = parseGameId(getParam(searchParams, 'game_id'));
  const coinType = parseCoinType(getParam(searchParams, 'coin_type'));

  useEffect(() => {
    if (!isBootReady || !isSlotGameLink || !gameId) {
      return;
    }
    localStorage.setItem(GAME_LAUNCH_TRIGGER, 'deep_link');
    const search = coinType ? `?${new URLSearchParams({ mode: coinType }).toString()}` : '';
    navigate(`/games/${gameId}${search}`, { replace: true });
  }, [isBootReady, isSlotGameLink, gameId, coinType, navigate]);
};
